/* BEATSEEK Verified ID badge — magenta starburst, knocked-out headphones with a check between the cups.
   Shown only on IDs the crowd has locked in (3+ confirmations, or a moderator lock). */
import React from 'react';

export const VerifiedIdBadge = ({ size = 22, title = 'Verified by BeatSeekers' }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      role="img"
      aria-label={title}
      data-testid="verified-id-badge"
      style={{ flexShrink: 0, filter: 'drop-shadow(0 0 5px rgba(255,0,153,0.55))' }}
    >
      <title>{title}</title>
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ff4fd8" />
          <stop offset="55%" stopColor="#ff0099" />
          <stop offset="100%" stopColor="#b3006b" />
        </linearGradient>
        <mask id={`m${id}`}>
          {/* white = paint the starburst, black = knocked out to transparent */}
          <rect width="48" height="48" fill="#fff" />
          {/* headband */}
          <path
            d="M14 28v-4a10 10 0 0 1 20 0v4"
            fill="none"
            stroke="#000"
            strokeWidth="3"
            strokeLinecap="round"
          />
          {/* ear cups */}
          <rect x="10.6" y="26.4" width="5.6" height="9.6" rx="2.8" fill="#000" />
          <rect x="31.8" y="26.4" width="5.6" height="9.6" rx="2.8" fill="#000" />
          {/* check mark between the cups */}
          <path
            d="M19.9 28.9l3.4 3.6 6.6-7.2"
            fill="none"
            stroke="#000"
            strokeWidth="3.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </mask>
      </defs>
      {/* 12-point starburst */}
      <path
        d="M24 1.5l3.6 5.1 5.9-2.4.9 6.3 6.2 1.3-2 6 5.4 3.3-4.2 4.8 3.6 5.2-5.8 2.6.6 6.3-6.3-.5-2.9 5.7-5-3.9-5 3.9-2.9-5.7-6.3.5.6-6.3-5.8-2.6 3.6-5.2L4 19.1l5.4-3.3-2-6 6.2-1.3.9-6.3 5.9 2.4z"
        fill={`url(#g${id})`}
        mask={`url(#m${id})`}
      />
    </svg>
  );
};

export default VerifiedIdBadge;
